
import { motion } from "framer-motion";
import { SearchBar } from "@/components/SearchBar";
import { useIsMobile } from "@/hooks/use-mobile";
import { AuthCheck, LeaderboardSection, RecentReviewsSection, AddReviewSection } from "@/components/home";
import { DescriptionHeader } from "@/components/DescriptionHeader";

const Index = () => {
  const isMobile = useIsMobile();

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="min-h-screen bg-background px-0 py-0"
    >
      <main className={`container mx-auto ${isMobile ? 'px-2' : 'px-4'} py-4`}>
        <DescriptionHeader />
        <SearchBar />
        <AuthCheck>
          <LeaderboardSection />
          <RecentReviewsSection />
          <AddReviewSection />
        </AuthCheck>
      </main>
    </motion.div>
  );
};

export default Index;
